import { type FC } from 'react';
import { Button, Group } from '@mantine/core';
import { Link } from 'react-router';
import { getOrderPath } from '~/entities/order';
import { CopyInput } from '~/shared/ui/CopyInput';

interface RelatedOrderValueProps {
    orderId: string;
}

export const RelatedOrderValue: FC<RelatedOrderValueProps> = ({ orderId }) => {
    return (
        <Group
            align='flex-end'
            gap='xs'
        >
            <CopyInput value={orderId} />

            <Button
                component={Link}
                size='xs'
                to={getOrderPath('payout', orderId)}
                variant='light'
            >
                Открыть
            </Button>
        </Group>
    );
};
